import { RoutePoint } from '../../types';

import { mapActions } from '../reducer';

export const setRoutePoints = (routePoints: RoutePoint[]) => mapActions.setRoutePoints(routePoints);
